import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpMediaComponent} from './dcp-media.component';
import {MediaModule} from '@spartacus/storefront';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {VimeoUrlModule} from '@app/pipes/vimeo-url/vimeo-url.module';
import {YouTubeUrlModule} from '@app/pipes/you-tube-url/you-tube-url.module';

@NgModule({
  declarations: [
    DcpMediaComponent
  ],
  imports: [
    CommonModule,
    MediaModule,
    YouTubePlayerModule,
    VimeoUrlModule,
    YouTubeUrlModule
  ],
  exports: [
    DcpMediaComponent
  ]
})
export class DcpMediaModule {
}
